import { formatarBRL, precoDePromocao } from "../../helpers/dinheiro";

// O preço de um produto, com o "De > Por" quando há promoção.
//
// Existe para as três telas mostrarem a mesma coisa: a lista do catálogo, o
// modal de enviar catálogo e a vitrine que o cliente abre pelo link. Antes de
// existir, cada uma imprimia `formatarBRL(produto.price)` sozinho — e o preço
// antigo teria de ser repetido em três marcações diferentes, que é como uma
// delas acaba esquecida.
//
// A unidade ("/ m²") fica FORA de propósito: cada tela a escreve com o tamanho
// e a cor que combinam com o resto dela.
const PrecoDoProduto = ({ produto, className = "" }) => {
	if (produto?.price === null || produto?.price === undefined) {
		return (
			<span className={`text-xs text-muted-foreground ${className}`}>
				Sob consulta
			</span>
		);
	}

	const antes = precoDePromocao(produto);

	if (!antes) return <span className={className}>{formatarBRL(produto.price)}</span>;

	return (
		<span className={className}>
			<span className="mr-1 text-xs text-muted-foreground line-through">
				{formatarBRL(antes)}
			</span>
			<span className="font-semibold text-emerald-600 dark:text-emerald-400">
				{formatarBRL(produto.price)}
			</span>
		</span>
	);
};

export default PrecoDoProduto;
